import React, { Component } from "react"
import "./productsCategoriesCarousel.scss"
import Slider from "react-slick"
import "../../../../../assets/libraries/slick/slick.css"
import "../../../../../assets/libraries/slick/slick-theme.css"
import * as educationalDictionary from "../../../../../library/constants/educationalDictionary"
import { Link, withRouter } from "react-router-dom"
import * as routes from "../../../../../library/constants/routes"
import { chunk } from "lodash"

const NextArrow = (props) => {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ ...style, zIndex: "auto" }}
    />
  )
}

class ProductsCategoriesCarousel extends Component {
  composePageItems = () => {
    return chunk(educationalDictionary.subjects, 4)
  }

  categoryPath = (id) => {
    return `${routes.MARKETPLACE}?subjects=${id}`
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      nextArrow: <NextArrow />,
      arrows: true,
    }

    return (
      <div className="slider d-ie-none d-none-xs">
        <Slider {...settings}>
          {this.composePageItems().map((item, index) => (
            <div className="no-outline" key={index}>
              <div className="slider__page">
                {item.map((subject) => {
                  return (
                    <Link
                      to={this.categoryPath(subject.id)}
                      className="slider__item"
                      role="button"
                      key={subject.id}
                    >
                      <img
                        src={subject.image}
                        alt={subject.name}
                        className="slider__img"
                      />
                      <span className="slider__label">{subject.name}</span>
                    </Link>
                  )
                })}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    )
  }
}

export default withRouter(ProductsCategoriesCarousel)
